export default {
  name: 'BatchGiftSet',
  props: {
    componentData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [{
            type: '', // 按钮类型
            text: $it('com.cancel'), // 取消
            icon: '', // 按钮图标
            size: '', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$parent.close();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: $it('com.determine'), // 确定
            icon: '', // 按钮图标
            size: '', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.save()
            } // 按钮点击事件
          }
        ]
      },
      formConfig: {
        formValue: {
          IS_GIFT_SPLIT: '',
          DELIVER_NODE: '',
          INTERVAL_TIME: ''
        },
        formData: [
          {
            style: 'select',
            label: '拆单方式',
            width: 24,
            colname: 'IS_GIFT_SPLIT',
            options: [
              {
                value: 1,
                label: '不拆单'
              },
              {
                value: 2,
                label: '可拆单'
              },
              {
                value: 3,
                label: '赠品后发'
              }
            ],
            selectChange: (val) => {
              const isThree = val.value == 3
              this.queryForm(this.formConfig, 'DELIVER_NODE').style = isThree ? 'select' : ''
              this.queryForm(this.formConfig, 'INTERVAL_TIME').style = isThree ? 'input' : ''
              this.formConfig.formValue.DELIVER_NODE = ''
              this.formConfig.formValue.INTERVAL_TIME = ''
            }, // 选中事件，默认返回选中的值,默认返回当前值value
          },
          {
            style: 'select',
            label: '发货时点',
            width: 24,
            colname: 'DELIVER_NODE',
            options: [
              /* {
                value: 1,
                label: '主品平台发货后'
              },
              { 
                value: 2,
                label:'主品签收后发'
              }, */
              { 
                value: 3,
                label:'主品发货后多久发'
              },
            ]
          },
          {
            style: 'input',
            label: '间隔时长(小时)', // 间隔时长（小时）
            colname: 'INTERVAL_TIME',
            width: 24,
            regx: /^\d/,
          }
        ],
      },
    };
  },
  methods: {
    queryForm(formConfig, field) {
      return formConfig.formData.find((item) => item.colname == field);
    },
    save() {
      const { IS_GIFT_SPLIT, DELIVER_NODE, INTERVAL_TIME } = this.formConfig.formValue
      if (IS_GIFT_SPLIT == 3 && (DELIVER_NODE == '' || INTERVAL_TIME == '')) {
        return $fcError('发货时点或间隔时长不能为空！')
      }
      this.$parent.$parent.$parent.handleBatchSet(this.formConfig.formValue);
      this.$parent.close();
    }
  }
};